import Call from '../Call.v3';
import qs from "querystring";

const BidderPluginReport = {
    get(filters, group_by, realtime) {
        return Call(`wbidder/plugin_report?${qs.stringify({ ...filters, group_by, realtime })}`);
    },
    distinct(field, filters) {
        return Call(`wbidder/plugin_report/distinct/${field}?${qs.stringify(filters)}`)
    }
};

export default BidderPluginReport;



// WEBPACK FOOTER //
// ./src/services/API/components/BidderPluginReport.js